import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-utm-detail',
  templateUrl: './view-utm-detail.component.html',
  styleUrls: ['./view-utm-detail.component.scss']
})
export class ViewUtmDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
